import { chatPickUp, chatsOnHoldFocused } from '@src/reducers/chats';
import { allChatsSelector } from '@src/selectors/chats';
import { connect } from 'react-redux';
import { resetAgentStartedChat } from '../../actions/agentconsole';
import AwaitingChatDialog from './AwaitingChatDialog';

// Maps the state of the store to a set of props that will provide the presentational component with part of the state
const mapStateToProps = state => ({
  latestStartChatRequest: state.agentConsole.latestStartChatRequest,
  chats: allChatsSelector(state),
});

// Maps the action creators to a set of props that will be passed as functions to the presentational component
const mapDispatchToProps = {
  onResetAgentStartedChat: resetAgentStartedChat,
  onRequestChatPickup: chatPickUp,
  onChatsOnHoldFocused: chatsOnHoldFocused,
};

// This is a container component. It owns the state of the ChatMessageComposer presentational component
const AwaitingChatDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AwaitingChatDialog);

export default AwaitingChatDialogContainer;
